module.exports = {"420684001":"鄢城街道","420684002":"南营街道","420684102":"郑集镇","420684103":"小河镇","420684104":"刘猴镇","420684105":"孔湾镇","420684106":"流水镇","420684107":"板桥镇","420684108":"王集镇","420684109":"雷河镇","420684400":"襄南监狱","420684401":"劳教所","420684450":"大雁工业园区","420684452":"宜城经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420684.json
// module id = 1746
// module chunks = 0